module.exports = __webpack_public_path__ + "static/b0c010aa1c99546f2d1a1d8a9ee865a2b6096c6dbd024cb0daf07613bd9d2043-0ca457d11e829080822fecd65a076332.png";